import jsCookie from 'js-cookie';

import { MOBILE_BREAKBOINT, TABLET_BREAKBOINT } from 'constants/Global';

/**
 * isMobile.
 * @type {boolean}
 */
let mobile = null;

/**
 * isMobileOrTablet.
 * @type {boolean}
 */
let mobileOrTablet = null;

/**
 * Determine if current browser is mobile, based on window size.
 * @return {Boolean} true if window size is mobile, false otherwise.
 */
function isMobile() {
    if (mobile === null) {
        mobile =
            !!window.matchMedia && window.matchMedia(`(max-width: ${MOBILE_BREAKBOINT})`).matches; // We are mobile because the media query rule match
    }
    return mobile;
}

/**
 * Determine if current browser is mobile or tablet, based on window size.
 * @return {Boolean} true if window size is mobile or tablet, false otherwise.
 */
function isMobileOrTablet() {
    if (mobileOrTablet === null) {
        mobileOrTablet =
            !!window.matchMedia && window.matchMedia(`(max-width: ${TABLET_BREAKBOINT})`).matches; // We are mobile or tablet because the media query rule match
    }
    return mobileOrTablet;
}

/**
 * Is app run in iOS/Android app webView
 * @return {boolean}
 */
function isAppInWebView() {
    return jsCookie.get('estimaWebView') === '1';
}

/**
 * Determine if current browser has touch events.
 * @return {Boolean} true if touch events are active, false otherwise
 */
function hasTouchEvents() {
    // From Modernizr 3 touchevent test, not 100% reliable but OK for our user population
    return Boolean(
        'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch),
    );
}

/**
 * Add class .no-touch to body if device doesn't have touch events
 */
function initTouchEvent() {
    if (!hasTouchEvents()) {
        document.body.className += ' no-touch';
    }
}

/**
 * Checking if we are in a browser or not
 * @type {Boolean}
 */
const isBrowser = !(
    typeof process === 'object' &&
    String(process) === '[object process]' &&
    !process.browser
);

export { isBrowser, isMobile, isMobileOrTablet, isAppInWebView, hasTouchEvents, initTouchEvent };
